import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { classicProjectSettingsSoftwareProformaFormsRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/classicProjectSettingsSoftwareProformaFormsRoute.tsx';
import { classicSoftwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';
import ProformaProjectForms, {
	LazyProjectSettingsProformaProjectForms,
} from './ui/project-settings/proforma-project-forms/index.tsx';

export const classicProjectSettingsSoftwareProformaFormsRouteEntry: Route = createEntry(
	classicProjectSettingsSoftwareProformaFormsRoute,
	() => ({
		group: 'project-settings-software',
		// eslint-disable-next-line no-restricted-syntax
		component: ProformaProjectForms,
		layout: classicSoftwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources()],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsProformaProjectForms],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
